import roundSlider from "./RoundSlider";
import doughnutChart from "./DoughnutChart";
import stackedBarChart from "./StackedBarChart";

export const RoundSlider = roundSlider;
export const DoughnutChart = doughnutChart;
export const StackedBarChart = stackedBarChart;
